import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import React, { FunctionComponent } from 'react';

import Machine from '../../../../models/Machine';

interface IProps {
  machine: Machine;
  deleteMachine: (machineId: number) => void;
  loading: boolean;
  closeDeleteMachine: () => void;
}

const DeleteConfirmation: FunctionComponent<IProps> = (properties) => {
  const { closeDeleteMachine, deleteMachine, loading, machine } = properties;

  return (
    <Dialog open onClose={() => closeDeleteMachine()}>
      <DialogTitle>
        <FontAwesomeIcon className="header-icon" icon={faTrash} />
        <span style={{ marginLeft: '8px' }}>Apagar Máquina - #{machine.id || ''}</span>
        <IconButton edge="end" size="small" className="dialog-close-button" onClick={() => closeDeleteMachine()}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>Tem certeza que quer apagar máquina #{machine.id || ''}?</DialogContent>
      <Box p={2} pt={0}>
        <DialogActions>
          <Box mt={2}>
            <Grid container spacing={1}>
              <Grid item>
                <Button color="default" variant="contained" onClick={closeDeleteMachine}>
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  startIcon={
                    <FontAwesomeIcon icon={faTrash} />
                  }
                  variant="contained"
                  onClick={() => deleteMachine(machine.id)}
                >{loading ? <CircularProgress size={24} /> : 'Apagar'}</Button>
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default DeleteConfirmation;